import _ from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import Paper from '@material-ui/core/Paper';

//- Components
import FilterHeader from '../../components/table/FilterHeader';

//- Helpers
import { getGlobalClasses } from '../../themes';

//- Containers
import AuthUserContainer from '../../containers/AuthUser';
import EquipmentAssignmentContainer from '../../containers/EquipmentAssignment';
import LocationSelect from '../../components/advancedForm/LocationSelect';
import FormComponent from '../../components/FormComponent';
import { Button, Grid } from '@material-ui/core';
import EquipmentAssignmentTable from './Table';
import localStorage from '../../libs/localStorage';
import SaveEquipmentDialog from '../../components/dialogs/Equipment/SaveEquipmentDialog';

const statusNamesToClassName = {
	retired: {
		color: '#616161',
		fontWeight: 900,
	},
	retiredStillAssigned: {
		fontWeight: 900,
		color: '#FF500F',
	},
	active: {
		fontWeight: 900,
		color: '#4CAF50',
	},
};

const styles = (theme) => {
	return {
		...statusNamesToClassName,
		...getGlobalClasses(theme),
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		showPast: {
			borderBottom: '2px solid #eee',
			marginBottom: 30,
			paddingTop: 5,
			paddingBottom: 15,
		},
		sortGroupCell: {
			border: `1px solid #bbb`,
			overflowX: 'hidden',
			height: 'auto',
			position: 'relative',
			padding: 10,
			//backgroundColor : '#D1C4E9',
			textTransform: 'uppercase',
			letterSpacing: 2,
			color: 'white',
			fontWeight: 500,
		},
		geoTabComment: {
			fontSize: '85%',
			color: '#666',
			paddingLeft: 5,
		},
		typeCount: {
			fontSize: '80%',
			paddingLeft: 10,
			letterSpacing: 1,
		},
		addButton: {
			verticalAlign: 'middle',
			textDecoration: 'none',
			marginBottom: 0,
			fontSize: 16,
			borderRadius: 100,
			padding: '8px 30px',
			marginTop: 10,
		},
	};
};

const locationStorageKey = '/equipmentAssignment/list/locationId';
class EquipmentAssignments extends FormComponent {
	constructor(props) {
		super(props);

		const selectedLocationId = localStorage.getItem(locationStorageKey);
		this.state = {
			order: 'asc',
			orderBy: 'parentChildDisplayName',
			filter: '',
			tabIndex: 0,
			filterMap: {},
			showPast: false,
		};
		if (selectedLocationId) {
			this.state.selectedLocationId = selectedLocationId;
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.selectedLocationId !== prevState.selectedLocationId) {
			localStorage.setItem(locationStorageKey, this.state.selectedLocationId);
		}
	}
	handleAdd = () => {
		this.setState({
			isSaveDialogOpen: true,
		});
	};
	handleSaveDialogClosed = () => {
		this.setState({
			isSaveDialogOpen: false,
		});
	};

	render() {
		const { classes, equipmentAssignments } = this.props;

		const { selectedLocationId, showPast } = this.state;

		if (!equipmentAssignments) {
			return <div>Fetching...</div>;
		}

		const { isSaveDialogOpen, equipmentAssignmentToUpdate } = this.state;

		return (
			<Fragment>
				<Grid container>
					<Grid item md={8}>
						<FilterHeader
							value={this.state.filter}
							onChange={this.handleFilter}
							label={'Truck Assignments'}
							canMakeUpdates={true}
						/>
					</Grid>
					<Grid item md={4} style={{ textAlign: 'right' }}>
						<Button
							className={classes.addButton}
							onClick={this.handleAdd}
							variant="contained"
							color="primary"
						>
							Add Truck Assignment
						</Button>
					</Grid>
				</Grid>

				<Paper className={classes.globalMainPaper}>
					<Grid container className={classes.showPast}>
						<LocationSelect
							{...this.setForm('selectedLocationId', 'Terminal', true)}
							gridProps={{ md: 4 }}
							showAll={true}
						/>
					</Grid>

					<EquipmentAssignmentTable
						{...this.props}
						includeEdit={true}
						selectedLocationId={selectedLocationId}
						showPast={showPast}
					/>

					<SaveEquipmentDialog
						open={isSaveDialogOpen}
						onClose={this.handleSaveDialogClosed}
						equipmentAssignmentToUpdate={equipmentAssignmentToUpdate}
						equipmentMap={this.props.equipmentMap}
					/>
				</Paper>
			</Fragment>
		);
	}
}

EquipmentAssignments.propTypes = {
	classes: PropTypes.object.isRequired,

	searchEquipmentAssignments: PropTypes.func.isRequired,
	equipmentAssignments: PropTypes.array,
	equipmentMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	EquipmentAssignmentContainer,
])(EquipmentAssignments);
